import superMeta from '../_CATEGORY_ROOT/metaCategoryRootNode.mjs'

export default {
    ...superMeta,
    name: '数据域',
    type: 'CAT_ROOT_DATA',
}
